
export const API_URL =
  process.env.REACT_APP_API_URL || 'https://api.socialproject.pl';

export const WS_URL =
  process.env.REACT_APP_WS_URL || 'wss://ws.socialproject.pl';

export const NA_ATRAPIE = API_URL.includes('localhost');

const trybDeweloperski = process.env.NODE_ENV === 'development';
const celujeWProdukcje =
  /socialproject\.pl/.test(API_URL) || /socialproject\.pl/.test(WS_URL);
const swiadomaZgoda = process.env.REACT_APP_POZWOL_PRODUKCJA === 'tak';

if (trybDeweloperski && celujeWProdukcje && !swiadomaZgoda) {
  const komunikat = [
    '',
    '  ZATRZYMANO: lokalny serwer celuje w PRODUKCJE.',
    '',
    '  API: ' + API_URL,
    '  WS:  ' + WS_URL,
    '',
    '  Kazde klikniecie przesunieloby prawdziwe tasks zespolu',
    '  i wyslalo ping na Discorda.',
    '',
    '  Utworz file todo-app/.env.local o tresci:',
    '',
    '    REACT_APP_API_URL=http://localhost:4000',
    '    REACT_APP_WS_URL=ws://localhost:4001',
    '',
    '  i uruchom serwer od draft (zmienne czytane sa przy starcie).',
    '',
    '  Jesli NAPRAWDE chcesz pracowac na produkcji, dopisz tam:',
    '    REACT_APP_POZWOL_PRODUKCJA=tak',
    '',
  ].join('\n');

  console.error(komunikat);
  throw new Error(komunikat);
}
